export default __webpack_public_path__ + "static/media/blizzard-small-sack.872c850e.png";